// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MehFilledSvg from "@ant-design/icons-svg/es/asn/MehFilled";
import AntdIcon from '../components/AntdIcon';

var MehFilled = function MehFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MehFilledSvg
  }));
};

MehFilled.displayName = 'MehFilled';
export default React.forwardRef(MehFilled);